export const adjustTooltipHeight = (reference) => {
  if (reference.current) {
    reference.current.style.height = "inherit";
    reference.current.style.height = `${reference.current.scrollHeight}px`;
  }
};
